import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';

@Injectable()
export class SchedulerService {
  private readonly apiPrefix = '/admin/scheduler';

  constructor(private api: ApiService) {}

  getJobs(qs = '') {
    return this.api.get(`${this.apiPrefix}${qs}`);
  }

  getJob(id: number) {
    return this.api.get(`${this.apiPrefix}/${id}`);
  }

  createJob(data: object) {
    return this.api.post(this.apiPrefix, data);
  }

  updateJob(id: number, data: object) {
    return this.api.patch(`${this.apiPrefix}/${id}`, data);
  }

  deleteJob(id: number) {
    return this.api.delete(`${this.apiPrefix}/${id}`);
  }

  pauseJob(id: number) {
    return this.api.patch(`${this.apiPrefix}/${id}/pause`, {});
  }

  resumeJob(id: number) {
    return this.api.patch(`${this.apiPrefix}/${id}/resume`, {});
  }

  getPreview(id: number, limit = 5) {
    return this.api.get(`${this.apiPrefix}/${id}/preview?limit=${limit}`);
  }

  getExecutions(id: number, qs = '') {
    return this.api.get(`${this.apiPrefix}/${id}/executions${qs}`);
  }

  cancelExecution(jobId: number, executionId: number) {
    return this.api.delete(`${this.apiPrefix}/${jobId}/executions/${executionId}`);
  }

  previewFromParams(payload: object) {
    return this.api.post(`${this.apiPrefix}/preview`, payload);
  }

  regenerateExecution(id: number) {
    return this.api.post(`${this.apiPrefix}/${id}/regenerate-execution`, {});
  }

  simulateUpdate(id: number, payload: object) {
    return this.api.post(`${this.apiPrefix}/${id}/simulate-update`, payload);
  }
}
